import { render, staticRenderFns } from "./NewFeaturesTable.vue?vue&type=template&id=3dfe458e&"
import script from "./NewFeaturesTable.vue?vue&type=script&lang=js&"
export * from "./NewFeaturesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports